<template>
  <div class="view">
    <Title title="銀行情報"/>
    <BankEditMain />
  </div>
</template>

<script>
import Title from '@/components/Title.vue'
import BankEditMain from '@/components/Bank/EditMain'

export default {
  components: {
    Title,
    BankEditMain
  }
}
</script>
